import React from 'react';
import type { FC } from 'react';

import { SelectFormGroup, type SelectFormGroupProps } from '@admin/components/fields/select_form_group';
import { Vehicle__Status } from '@admin/schema';

const OPTIONS = [
  { value: Vehicle__Status.Active, name: 'Active' },
  { value: Vehicle__Status.Grounded, name: 'Grounded' },
  { value: Vehicle__Status.Inactive, name: 'Inactive' },
  { value: Vehicle__Status.Management, name: 'Management' },
  { value: Vehicle__Status.Excess, name: 'Excess' },
];

export type VehicleStatusSelectFormGroupProps = Omit<SelectFormGroupProps, 'value' | 'children' | 'onChange'> & {
  value?: Vehicle__Status;
  onChange(value: Vehicle__Status | undefined): void;
};

export const VehicleStatusSelectFormGroup: FC<VehicleStatusSelectFormGroupProps> = ({ value, onChange, ...props }) => (
  <SelectFormGroup
    {...props}
    value={value ?? ''}
    onChange={(event) => onChange((event.target.value || undefined) as Vehicle__Status)}
  >
    <option value=""> - All - </option>

    {OPTIONS.map((option, key) => (
      <option value={option.value} key={key}>
        {option.name}
      </option>
    ))}
  </SelectFormGroup>
);
